import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { FacebookLogo, Link, LinkedinLogo, TwitterLogo } from 'phosphor-react';
import { Button } from 'src/common/components/button/button';
import { SocialShareButton } from 'src/common/components/social-share-button/social-share-button';

import './social-sharing.css';

type SocialSharingProps = {
  url: string;
};

export const SocialSharing = ({ url }: SocialSharingProps) => (
  <aside className="social-sharing">
    <SocialShareButton
      target="twitter"
      url={url}
      className="social-sharing__icon-btn"
    >
      <TwitterLogo weight="fill" alt="Share on Twitter" width={16} />
    </SocialShareButton>
    <SocialShareButton
      target="facebook"
      url={url}
      className="social-sharing__icon-btn"
    >
      <FacebookLogo weight="fill" alt="Share on Facebook" width={16} />
    </SocialShareButton>
    <SocialShareButton
      target="linkedin"
      url={url}
      className="social-sharing__icon-btn"
    >
      <LinkedinLogo weight="fill" alt="Share on LinkedIn" width={16} />
    </SocialShareButton>
    <CopyToClipboard text={url}>
      <Button className="social-sharing__icon-btn">
        <Link weight="fill" alt="Copy URL" width={16} />
      </Button>
    </CopyToClipboard>
  </aside>
);
